import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    type: 'georadar',
    checkIsLoading: false,
    retrievePointsLoading: false,
    retrievePointsCount: 0,
    /**
     * Contains the legacy of georadar points that were originally audiences.
     * Is used in the builder.
     */
    list: [],

    /**
     * savedPoints contains all the points that exist in DB
     * It is the reflection of the database and must be used by the builder.
     * It must be updated when changes are made in the DB
     */
    savedPoints: [],

    /**
     * unSavedPoints contains all the points that exist in the frontend part
     * I.e. all the points that exist in the database with their possible modifications
     * as well as all the new points that have not yet been saved
     */
    unSavedPoints: []
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
